/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    /**
     * Checkbox tree for permission selecting
     */
    let permissionTree = $('.permission-tree :checkbox');

    permissionTree.on('click change', function (){
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        } else {
            $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    permissionTree.each(function () {
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        }
    });

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }
    window.enableSubmitButtons = enableSubmitButtons;

    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        disableSubmitButtons($(this));
        return true;
    });

    /**
     * Add a confirmation to a delete button/form
     */
    $('body').on('submit', 'form[name=delete-item]', function (e) {
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to delete this item?',
            showCancelButton: true,
            confirmButtonText: 'Confirm Delete',
            cancelButtonText: 'Cancel',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                this.submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    })
        .on('submit', 'form[name=confirm-item]', function (e) {
            e.preventDefault();
            var text = $(this).data('text');
            var title = $(this).data('title') || 'Are you sure you want to do this?';
            var noIcon = $(this).data('noicon') || 'false'
            var icon = '';
            if (!noIcon) {
                icon = 'warning';
            }
            Swal.fire({
                title: title,
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                icon: icon,
                text: text
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        })
        .on('submit', 'form[name=confirm-item-date]', function (e) {
            e.preventDefault();
            var text = $(this).data('text');
            var title = $(this).data('title') || 'Are you sure you want to do this?';
            var noIcon = $(this).data('noicon') || 'false'
            var icon = '';
            if (!noIcon) {
                icon = 'warning';
            }
            Swal.fire({
                title: title,
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                icon: icon,
                text: text,
                html: '<input id="confirm-item-datepicker" class="form-control mb-3" autofocus>',
                onOpen: function () {
                    $('#confirm-item-datepicker').datetimepicker({
                        format: 'YYYY-MM-DD',
                        locale: 'en',
                        icons: {
                            up: 'fas fa-chevron-up',
                            down: 'fas fa-chevron-down',
                            previous: 'fas fa-chevron-left',
                            next: 'fas fa-chevron-right'
                        },
                        inline: true,
                        sideBySide: true,
                    })
                },
            }).then((result) => {
                if (result.value) {
                    this.action += '/' + $('#confirm-item-datepicker').val();
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        })
        .on('submit', 'form[name=confirm-current-price]', function (e) {
            e.preventDefault();
            var text = $(this).data('text');
            var title = $(this).data('title') || 'Are you sure you want to do this?';
            var noIcon = $(this).data('noicon') || 'false'
            var icon = '';
            if (!noIcon) {
                icon = 'warning';
            }
            Swal.fire({
                title: title,
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                icon: icon,
                text: text,
                footer: '<div class="alert alert-info" role="alert"> This new price will apply immediately if it\'s your turn now. If it\'s passed you, in this bidding turn, and no one after you in this turn doesn\'t take the current price, this will be your new price for the next bidding turn.</div>'
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        })
        .on('submit', 'form[name=purchase-seat]', function (e) {
            e.preventDefault();

            var text = $(this).data('text');
            var title = $(this).data('title') || 'Are you sure you want to do this?';
            var noIcon = $(this).data('noicon') || 'false'
            var inputValue = $(this).data('value');
            var icon = '';
            if (!noIcon) {
                icon = 'warning';
            }
            Swal.fire({
                title: title,
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                icon: icon,
                html: text,
                onOpen: function () {
                    $('.swal2-content').append('<div class="alert alert-warning mt-1" role="alert">If you win this item, the dollar value that you put here will be the cost of the item that you will pay for separately.</div>');
                    $('.swal2-input').addClass('m-1').removeAttr('style');
                    $('.swal2-input').wrap('<span id="currency-input-wrapper"></span>');
                },
                customClass: 'swal-purchase-seat',
                input: 'number',
                inputValue: inputValue,
                inputValidator: function (value) {
                    value = $('.swal-purchase-seat input[type="number"]').val();
                    if (!value) {
                        return 'You need to specify the max bid price.';
                    }
                    if (parseFloat(value) < 0) {
                        return 'Max bid price cannot be less than $0.00';
                    }
                }
            }).then((result) => {
                result.value = $('.swal-purchase-seat input[type="number"]').val();
                if (result.isConfirmed && result.value) {
                    $(this).append('<input type="hidden" name="preset_bid_cents" value="' + result.value * 100 + '" />');
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        })
        .on('click', 'a[name=confirm-item]', function (e) {
            /**
             * Add an 'are you sure' pop-up to any button/link
             */
            e.preventDefault();

            Swal.fire({
                title: 'Are you sure you want to do this?',
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                icon: 'info',
            }).then((result) => {
                result.value && window.location.assign($(this).attr('href'));
            });
        });

    // Remember tab on page load
    $('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = $(e.target).attr('href');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        $('.nav-link[href="' + hash + '"]').tab('show');
    }

    // Enable tooltips everywhere
    $('[data-toggle="tooltip"]').tooltip();


    window._token = $('meta[name="csrf-token"]').attr('content')

    moment.updateLocale('en', {
        week: { dow: 1 } // Monday is the first day of the week
    })

    if ($('').datetimepicker != undefined) {
        $('.date').datetimepicker({
            format: 'MM/DD/YYYY',
            locale: 'en',
            icons: {
                up: 'fas fa-chevron-up',
                down: 'fas fa-chevron-down',
                previous: 'fas fa-chevron-left',
                next: 'fas fa-chevron-right'
            }
        })

        $('.datetime').datetimepicker({
            format: 'MM/DD/YYYY HH:mm:ss',
            locale: 'en',
            sideBySide: true,
            icons: {
                up: 'fas fa-chevron-up',
                down: 'fas fa-chevron-down',
                previous: 'fas fa-chevron-left',
                next: 'fas fa-chevron-right'
            }
        })

        $('.timepicker').datetimepicker({
            format: 'HH:mm:ss',
            icons: {
                up: 'fas fa-chevron-up',
                down: 'fas fa-chevron-down',
                previous: 'fas fa-chevron-left',
                next: 'fas fa-chevron-right'
            }
        })
    }

    $('.select-all').click(function () {
        let $select2 = $(this).parent().siblings('.select2')
        $select2.find('option').prop('selected', 'selected')
        $select2.trigger('change')
    })
    $('.deselect-all').click(function () {
        let $select2 = $(this).parent().siblings('.select2')
        $select2.find('option').prop('selected', '')
        $select2.trigger('change')
    })

    function formatCard(card) {
        if (!card.id) {
            return card.text;
        }

        var $state = $('<span><i class="' + card.element.dataset.icon + '"></i> ' + card.text + '</span>');
        return $state;
    };

    if ($('').select2 != undefined) {
        $('.select2:not(.payment-method-select2)').select2();

        $('.payment-method-select2').select2(
            {
                templateResult: formatCard
            }
        );
    }

    $('.treeview').each(function () {
        var shouldExpand = false
        $(this).find('li').each(function () {
            if ($(this).hasClass('active')) {
                shouldExpand = true
            }
        })
        if (shouldExpand) {
            $(this).addClass('active')
        }
    })

    $('button.sidebar-toggler').click(function () {
        setTimeout(function () {
            $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
        }, 275);
    })

    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })

    $(function () {
        setTimeout(function () {
            $.each($('.time-utc'), function (i, val) {
                var timestamp = Date.parse(val.innerText);

                if (isNaN(timestamp) == false) {
                    var date = new Date(timestamp);
                    $(val).text(date.toLocaleDateString('en-US') + ' ' + date.toLocaleTimeString('en-US'));
                }
            });
        }, 275);
    })




    /*
    if ($('.time-ago').length > 0) {
        updateTimeAgo();
        setInterval(function () {
            updateTimeAgo()
        }, 15000);
    }

    function updateTimeAgo() {
        $.each($('.time-ago'), function (index, value) {
            $(this).html(moment.tz($(value).data('date'), 'YYYY-MM-DD HH:mm:ss', 'America/Los_Angeles').fromNow());
        });
    }

    $.each($('.clock'), function (index, value) {
        $(value).countdown(moment.tz($(value).data('date'), 'MM/DD/YYYY HH:mm:ss', 'America/Los_Angeles').local().format('YYYY-MM-DD HH:mm:ss')).on('update.countdown', function (event) {
            var $this = $(this).html(event.strftime(''
                + '<div class="px-2"><span class="font-weight-bold">%D</span> Day%!d</div>'
                + '<div class="px-2"><span class="font-weight-bold">%H</span> Hr</div>'
                + '<div class="px-2"><span class="font-weight-bold">%M</span> Min</div>'
                + '<div class="px-2"><span class="font-weight-bold">%S</span> Sec</div>'));
        });
    });
*/
    /*
    $("form:has(input[class*='datetime'])").on('submit', function () {
        var form = $(this);
        console.log(form, form.find("input[class*='datetime']"));
        $.each(form.find("input[class*='datetime']"), function (index, value) {
            console.log(value);
            form.append('<input type="hidden" name="' + $(value).attr('name') + '_utc" value="' + moment($(value).val()).utc().format('MM/DD/YYYY HH:mm:ss') + '" />');
        })
    });
    */
});
